module.exports = __webpack_public_path__ + "static/media/gavel.67c48a81.svg";